var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12386_3450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12386_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 64C9.86667 64 8 63.2 6.4 61.6C4.8 60 4 58.1333 4 56V48C4 47.5333 4.06667 47.0333 4.2 46.5C4.33333 45.9667 4.46667 45.4667 4.6 45L16.6 16.8C17.2 15.4667 18.2 14.3333 19.6 13.4C21 12.4667 22.4667 12 24 12H68V64L44 87.8C43 88.8 41.8167 89.3833 40.45 89.55C39.0833 89.7167 37.7667 89.4667 36.5 88.8C35.2333 88.1333 34.3 87.2 33.7 86C33.1 84.8 32.9667 83.5667 33.3 82.3L37.8 64H12ZM60 60.6V20H24L12 48V56H48L42.6 78L60 60.6ZM80 12C82.2 12 84.0833 12.7833 85.65 14.35C87.2167 15.9167 88 17.8 88 20V56C88 58.2 87.2167 60.0833 85.65 61.65C84.0833 63.2167 82.2 64 80 64H68V56H80V20H68V12H80Z",
    fill: "#FDFDFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb_down.3149b63fbb9663018c7c753984244039.svg";
export { ForwardRef as ReactComponent };